"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateTextCellEditor = void 0;
const core_1 = require("@ag-grid-community/core");
class DuplicateTextCellEditor extends core_1.TextCellEditor {
    isCancelAfterEnd() {
        const newValue = this.getValue();
        const currentlyEditedNode = this.params.node;
        if (newValue === null || newValue === '') {
            return false;
        }
        let duplicateDetected = false;
        this.params.api.forEachNode((node, index) => {
            // check for duplicated value and ignore currently edited row
            if ((node.data[this.params.column.getColId()] === newValue)
                && currentlyEditedNode.id !== node.id) {
                duplicateDetected = true;
            }
        });
        if (duplicateDetected)
            if (!confirm(`Der Wert ${newValue} ist bereits vorhanden. Sind Sie sicher?`)) {
                return true;
            }
        return false;
    }
}
exports.DuplicateTextCellEditor = DuplicateTextCellEditor;
